import { FadedImage } from "../../FadedImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-about-nightly-curlers.jpg`;
const ALT = "Lara in curlers and glasses, laughing at her laptop late at night, warm lamp beside her and city lights through a dark window.";

export function NightlyGratitude() {
  return (
    <section data-testid="about-nightly-gratitude" className="relative overflow-hidden bg-[#FFFFFF]">
      <div className="relative w-full overflow-hidden reveal pb-10 lg:pb-[20px]">
        {/* Desktop image half-band, right side, 49% — feathered on the inside (left) edge only */}
        <div className="hidden lg:block absolute inset-y-0 right-0 w-[49%]">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="nightly-gratitude-image"
            bg="#FFFFFF"
            objectPosition="55% 32%"
            featherLeft={40}
            className="absolute inset-0"
          />
        </div>

        {/* Mobile image stacked on top */}
        <div className="lg:hidden relative w-full aspect-[4/5] mt-2">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="nightly-gratitude-image-mobile"
            bg="#FFFFFF"
            objectPosition="55% 28%"
            featherBottom={20}
            className="absolute inset-0"
          />
        </div>

        {/* Text on the clean left, 55% */}
        <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 pt-8 lg:pt-0 flex items-center lg:min-h-[min(64vh,540px)]">
          <div className="w-full lg:w-[51%]">
            <div className="max-w-[540px]">
              <p
                data-testid="nightly-gratitude-header"
                className="font-display text-[26px] md:text-[34px] text-[#1C1917] leading-[1.25] mb-5"
              >
                For more than five years, my favorite part of the day has
                started around 1 a.m. Eastern.
              </p>
              <div
                data-testid="nightly-gratitude-body"
                className="space-y-3 text-lg md:text-xl leading-relaxed text-[#57534E]"
              >
                <p>
                  While much of the world is getting ready for tomorrow,
                  people from around the globe gather for a simple
                  conversation about gratitude, hope and remembering what
                  matters.
                </p>
                <p>
                  We&rsquo;ve celebrated babies, new jobs, healing and second
                  chances.
                </p>
                <p>We&rsquo;ve held space for heartbreak too.</p>
                <p>
                  Night after night, I&rsquo;m reminded that showing up
                  exactly as you are is more than enough.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
